export const unscrambleId = (id: string): number => Number(id.split('.')[0]);

export const unscrambleStringId = (id: string): string => id.split('.')[0];
